/**
 * NoCodeBackend (NCB) Admin Service
 */

const PROXY_BASE = '/api/ncb';

const fetchProxy = async (method, operation, table, data = null, id = null, params = null) => {
  let path = `${operation}/${table}`;
  if (id) path += `/${id}`;
  
  let queryString = '';
  if (params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, val]) => {
      if (val !== undefined && val !== null) searchParams.append(key, val);
    });
    queryString = `?${searchParams.toString()}`;
  }
  
  const url = `${PROXY_BASE}/${path}${queryString}`;
  
  const options = {
    method: method,
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include' // Required for session cookie
  };

  if (data && (method === 'POST' || method === 'PUT')) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(url, options);
    const result = await response.json();
    
    if (!response.ok) {
      throw new Error(result.message || `NCB ${operation} failed: ${response.status}`);
    }

    return result;
  } catch (err) {
    console.error(`[Admin NCB Service] Error:`, err);
    throw err;
  }
};

export const ncbService = {
  getAllRecords: async (table, customLimit = 100) => {
    let allData = [];
    let currentPage = 1;
    let hasMore = true;
    while (hasMore && currentPage <= 50) {
      const response = await fetchProxy('GET', 'read', table, null, null, { page: currentPage, limit: customLimit });
      const data = response.data || [];
      allData = [...allData, ...data];
      hasMore = response.metadata?.hasMore === true;
      if (hasMore) currentPage++;
    }
    return allData;
  },

  // Admin Bookings
  getBookings: () => ncbService.getAllRecords('bookings'),
  updateBooking: (id, data) => fetchProxy('PUT', 'update', 'bookings', data, id),
  deleteBooking: (id) => fetchProxy('DELETE', 'delete', 'bookings', null, id),

  // Admin Gallery
  createGalleryImage: (data) => fetchProxy('POST', 'create', 'gallery_images', data),
  updateGalleryImage: (id, data) => fetchProxy('PUT', 'update', 'gallery_images', data, id),
  deleteGalleryImage: (id) => fetchProxy('DELETE', 'delete', 'gallery_images', null, id),

  // Admin Settings
  updateSiteSetting: (id, data) => fetchProxy('PUT', 'update', 'site_settings_7523', data, id),
  updatePageSection: (id, data) => fetchProxy('PUT', 'update', 'page_sections_7523', data, id),
  updateBusinessProfile: (id, data) => fetchProxy('PUT', 'update', 'business_profile_7523', data, id)
};